export default __webpack_public_path__ + "static/media/maze.c28425f5.jpg";